import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { CoreHttpService } from 'src/app/providers/core-http/core-http.service';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})

export class EmailTemplateService extends CoreHttpService {

  private emailTemplateUrl: string = `${environment.apiUrl}/EmailTemplate`;

  constructor(
    private _httpService: HttpClient,
    router: Router,
    spinner: NgxSpinnerService
  ) {
    super(_httpService, router, spinner);
  }

  getCurrentUserFootPrint() {
    return this._httpService.get("https://ipapi.co/json/");
  }

  getEmailTemplateList(paramEmailTemplateId: number) {
    return this.get(`${this.emailTemplateUrl}/GetEmailTemplateList?emailTemplateId=${paramEmailTemplateId}&moduleMasterId=0`);
  }

  getEmailTemplateByModuleMasterId(moduleMasterId: number) {
    return this.get(`${this.emailTemplateUrl}/GetEmailTemplateList?emailTemplateId=0&moduleMasterId=${moduleMasterId}`);
  }
  
  addUpdateModuleEmailTemplate(requestModel: any) {
    return this.post(`${this.emailTemplateUrl}/AddUpdateModuleEmailTemplate`, requestModel);
  }
}
